<template>
  <div>
    <div class="contact">
      <title-screen title="11"></title-screen>
        <h4 class="reed_color">初回無料相談について</h4>
        <p class="al-c"><img src="../../../images/contact_text.jpg" alt="相続専門のベテランスタッフが、相続税等に関するあなたのご質問やご相談にメール又は面談にてお答えします。" width="631" height="66" /></p>
        <p>
            ※初回のご相談を無料とさせて頂きますが、内容によって、業法上又は無料でお答えできないこともございますので、あらかじめご了承下さい。<br>
            ※同業者の方はお断りさせて頂いております。
        </p>
        <h5 class="reed03">初回面談無料相談の予約専用電話</h5><br>
        <div id="contact_btn">
            <p class="float-l">
                <span id="phone_number_holder_1">0120-501-725</span>
                <span id="business_hours">平日／土日祝日　9:00 - 17:30</span>
            </p>
            <ul class="float-none">
                <li><a href="#form"><img src="../../../images/consultation_btn01.jpg" alt="初回無料相談フォーム" width="178" height="46"></a></li>
                <li><a href="https://legacy.ne.jp/claim/" target="_blank" rel="noopener noreferrer"><img src="../../../images/consultation_btn02.jpg" alt="資料請求" width="147" height="46"></a></li>
            </ul>
        </div>
        <span id="form"></span>
        <p class="bold-txt link01">・ご連絡頂いた上で、お伺いさせて頂くことも可能（無料）です。<br>
            ・「相続のせんせいを見て、面談相談を希望」とお伝え下さい。<br>
            ・法人所在地は<a href="http://legacy.ne.jp/company/company06/" style="color: #820404;" target="_blank" rel="noopener noreferrer">こちら</a></p>
        <h5 class="reed_color">初回無料相談フォーム</h5><br>
      <confirm-change-before-route ref="confirm-before-route">
      <el-form class="form mt2" ref="form" :model="form" :rules="rules">
        <table class="table">
          <tbody>
          <tr>
            <td class="title required">お名前</td>
            <td class="column-input">
              <div class="d-flex">
                <el-form-item prop="lastName" class="w-45p mr-auto" style="margin-bottom: 10px"><input :disabled="formDisabled" type="text" v-model="form.lastName" placeholder="姓" class="el-input__inner"></el-form-item>
                <el-form-item prop="firstName" class="w-45p" style="margin-bottom: 10px"><input :disabled="formDisabled" type="text" v-model="form.firstName" placeholder="名" class="el-input__inner"></el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td class="title">フリガナ</td>
            <td>
              <div class="d-flex">
                <el-input :disabled="formDisabled" class="w-45p mr-auto" placeholder="セイ" v-model="form.lastNameKana"></el-input>
                <el-input :disabled="formDisabled" class="w-45p" placeholder="メイ" v-model="form.firstNameKana"></el-input>
              </div>
            </td>
          </tr>
          <tr>
            <td class="title">電話番号</td>
            <td class="tel">
              <el-form-item prop="phone">
                <el-input :disabled="formDisabled" type="text" class="max-width-300 mr-3 width-60-p d-inline-block" v-model="form.phone"></el-input>
                <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="title">携帯電話番号</td>
            <td class="tel">
              <el-form-item prop="mobilePhone">
                <el-input :disabled="formDisabled" type="text" class="max-width-300 mr-3 width-60-p d-inline-block" v-model="form.mobilePhone"></el-input>
                <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="title required">メールアドレス</td>
            <td class="email-contact">
              <el-form-item
                class="pb-3"
                prop="email"
                :rules="[
                  { required: true, message: this.$t('rules.email'), trigger: 'blur' },
                  { type: 'email', message: this.$t('rules.email'), trigger: ['blur', 'change'] }
                ]">
                <el-input :disabled="formDisabled" type="email" v-model="form.email"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
              <td class="title required">お住いの都道府県</td>
              <td class="prefecture-contact">
                  <el-form-item prop="prefecture" style="margin-bottom: 10px">
                    <prefecture-select
                        :changeAction="prefectureChange"
                        v-model="form.prefecture"
                        :prefectureMaster="prefectureMaster"
                        :disabled="formDisabled"
                      ></prefecture-select>
                  </el-form-item>
              </td>
          </tr>
          <tr>
            <td class="title">面談希望日</td>
            <td class="begin-date">
              <div class="begin-date-group d-block">
                  <div class="title-date-group">
                      第一希望日
                  </div>
                <div class="date-group">
                    <el-date-picker
                        class="col-xxs-12 begin-date"
                        @change="$refs['confirm-before-route'].change()"
                        v-model="form.beginDateFirst"
                        :disabled="formDisabled"
                        type="date"
                        placeholder="" :editable="false" value-format="yyyy年MM月dd日"
                        :picker-options="beginDatePickerOptionsForFirstAndSecondChoice">
                    </el-date-picker>
                    <el-select :disabled="formDisabled" @change="$refs['confirm-before-route'].change()" class="begin-hour-group" v-model="form.beginHourFirst" placeholder="選択してください">
                        <el-option
                            v-for="(hour, index) in form.beginHours"
                            :key="index"
                            :label="hour"
                            :value="hour">
                        </el-option>
                    </el-select>
                </div>
              </div>
              <div class="begin-date-group d-block">
                  <div class="title-date-group">
                      第二希望日
                  </div>
                  <div class="date-group">
                      <el-date-picker
                          class="col-xxs-12 begin-date"
                          @change="$refs['confirm-before-route'].change()"
                          v-model="form.beginDateSecond"
                          :disabled="formDisabled"
                          type="date" value-format="yyyy年MM月dd日"
                          placeholder="" :editable="false"
                          :picker-options="beginDatePickerOptionsForFirstAndSecondChoice">
                      </el-date-picker>
                      <el-select :disabled="formDisabled" @change="$refs['confirm-before-route'].change()" class="begin-hour-group" v-model="form.beginHourSecond" placeholder="選択してください">
                          <el-option
                              v-for="(hour, index) in form.beginHours"
                              :key="index"
                              :label="hour"
                              :value="hour">
                          </el-option>
                      </el-select>
                  </div>
              </div>
              <div class="begin-date-group d-block">
                  <div class="title-date-group">
                      第三希望日
                  </div>
                  <div class="date-group">
                      <el-date-picker
                          class="col-xxs-12 begin-date"
                          @change="$refs['confirm-before-route'].change()"
                          v-model="form.beginDateThird"
                          :disabled="formDisabled"
                          type="date" value-format="yyyy年MM月dd日"
                          placeholder="" :editable="false"
                          :picker-options="beginDatePickerOptions">
                      </el-date-picker>
                      <el-select :disabled="formDisabled" @change="$refs['confirm-before-route'].change()" class="begin-hour-group" v-model="form.beginHourThird" placeholder="選択してください">
                          <el-option
                              v-for="(hour, index) in form.beginHours"
                              :key="index"
                              :label="hour"
                              :value="hour">
                          </el-option>
                      </el-select>
                  </div>
              </div>
              <div>
                ※ご希望を伺いまして、面談の日時を調整させていただきます。<br>
                <span style="margin-left: 15px;">面談希望日はご希望に沿えない場合がございます。</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="title">ご希望の面談場所</td>
            <td style="vertical-align: center;">
              <el-form-item>
                <el-checkbox-group v-model="form.meetingPlace" :disabled="formDisabled">
                  <el-checkbox label="ご来社" class="col-xs-12 vertical-align-top mr1"></el-checkbox>
                  <span class="mr1">
                    ※アクセスは<a href="https://legacy.ne.jp/company/company06/#map" style="color: #820404;" target="_blank" rel="noopener noreferrer">こちら</a>
                  </span>
                  <el-checkbox label="テレビ電話（ご自宅のパソコンをご利用いただきます）" class="col-xs-12 vertical-align-top mr1"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="title required">ご相談内容</td>
            <td>
              <el-form-item prop="inquiryConsultationDetail">
                <el-checkbox-group v-model="form.inquiryConsultationDetail" :disabled="formDisabled">
                  <el-checkbox v-for="item in inquiryConsult" :key="item.itemKey" :label="item.itemValue.trim()" class="col-xs-12 vertical-align-top mr1">
                    {{item.itemValue}}
                  </el-checkbox>
                </el-checkbox-group>
                ※複数選択可<br>
                ご自由にご記入ください。
                <el-input type="textarea" :disabled="formDisabled" v-model="form.contentOfConsultation" rows="3"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="title required">当社からのご連絡方法</td>
            <td>
              <el-form-item prop="contactUs">
                <el-checkbox-group v-model="form.contactUs" :disabled="formDisabled">
                  <el-checkbox v-for="item in inquiryContact" :key="item.itemKey" :label="item.itemValue.trim()" class="vertical-align-top mr1">
                    {{item.itemValue}}
                  </el-checkbox>
                </el-checkbox-group>
                ※複数選択可
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="title required">相続のせんせいを知ったきっかけ</td>
            <td>
              <el-form-item prop="knowAbout">
                <div><strong>検索エンジン</strong></div>
                <div class="">
                  <el-radio-group v-model="form.learnedAbout" :disabled="formDisabled">
                    <el-radio v-for="item in inquirySerch"
                              :key="item.itemKey"
                              :label="item.itemValue"
                              class="mr1 xs-mr-10">{{item.itemValue}}
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="">検索キーワード</div>
                <div class="">
                  <el-input v-model="form.searchKeyword" :disabled="formDisabled"></el-input>
                  <small>例）相続相談</small>
                </div>
                <div class="">
                  <el-checkbox v-model="form.financialInstitution" :disabled="formDisabled" class="vertical-align-top">金融機関・葬儀社等から紹介を受けた［金融機関名・葬儀社名］</el-checkbox>
                </div>
                <div class="mt-10-m">
                  <el-input v-model="form.bankBranch" :disabled="formDisabled"></el-input>
                  <small>例）○○銀行○○支店</small>
                </div>
                <div class="">
                  <el-checkbox v-model="form.other" :disabled="formDisabled" class="vertical-align-top">その他</el-checkbox>
                </div>
                <div class="">
                  <el-input v-model="form.otherText" :disabled="formDisabled"></el-input>
                </div>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="title">顧問税理士有無</td>
            <td>
              <el-radio-group v-model="form.consultantTaxAdvisor" :disabled="formDisabled">
                <el-radio v-for="item in inquiryAdvisor"
                          :key="item.itemKey"
                          :label="item.itemValue"
                          class="mr1">{{item.itemValue}}
                </el-radio>
              </el-radio-group>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="mt2 text-center privacy-policy">
          <el-checkbox v-model="form.privacyPolicy" @change="handlePrivacyPolicy" :disabled="formDisabled">
            <a href="https://legacy.ne.jp/privacy-customer/" target="_blank" rel="noopener noreferrer"><span style="font-size: 18px; color: #006ce5;">「個人情報の取扱いについて」同意します</span></a>
          </el-checkbox>
          <div class="warning-policy" v-if="checkPolicy">
            「「個人情報の取扱いについて」同意します」にチェックしてください
          </div>
        </div>
        <div v-if="isConfirm">
          <div class="mt2 text-center btn-contact">
            <el-button class="btn button-color button-large-height gtm_top_inquiry_done" @click="sendEmail" ><span class="gtm_top_inquiry_done">送信する</span></el-button>
            <el-button class="btn button-color button-large-height" @click="handleBack">戻る</el-button>
          </div>
        </div>
        <div v-else>
          <div class="mt2 text-center btn-contact" v-show="policy">
            <el-button class="btn button-color button-large-height" @click="registerContact">確認する</el-button>
            <el-button class="btn button-color button-large-height" @click="resetForm('form')">クリア</el-button>
          </div>
          <div class="mt2 text-center btn-contact" v-show="policy2">
            <el-button class="btn button-color button-large-height" @click="registerContact">確認する</el-button>
            <el-button class="btn button-color button-large-height" @click="resetForm">クリア</el-button>
          </div>
        </div>
      </el-form>
      </confirm-change-before-route>
    </div>
    <confirm-dialog
      ref="confirm-reset-form"
    ></confirm-dialog>
  </div>
</template>
<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import contact from '@/api/contact/contact-cl'
    import TitleScreen from '@/components/common/TitleScreen'
    import ConfirmDialog from '../../../components/dialog/ConfirmDialog'
    import ConfirmChangeBeforeRoute from '../../../components/common/ConfirmChangeBeforeRoute'
    import ApiHoliday from '@/api/invoice/holiday.js'
    import { MessageBox } from 'element-ui'
    import PrefectureSelect from '@/components/common/PrefectureSelect'
    import { isIE } from '@/common/useragent'

    export default {
        components: {
          ConfirmChangeBeforeRoute,
          ConfirmDialog,
          TitleScreen,
          PrefectureSelect
        },
        data () {
          var validateInquiryConsultationDetail = (rule, value, callback) => {
            if (this.form.inquiryConsultationDetail.length === 0 && this.form.contentOfConsultation === '') {
              callback(new Error('ご相談内容にチェック、もしくは、ご記入をお願いします'))
            } else {
              callback()
            }
          }
          var validateContactUs = (rule, value, callback) => {
            if (this.form.contactUs.length === 0) {
                callback(new Error(this.$t('rules.required', { key: '当社からのご連絡方法' })))
            } else {
                callback()
            }
          }
          var validateKnowOutWeb = (rule, value, callback) => {
            if (this.form.learnedAbout.trim() !== '' || (this.form.financialInstitution && this.form.bankBranch.trim() !== '') || (this.form.other && this.form.otherText.trim())) {
                callback()
            } else {
                callback(new Error(this.$t('rules.required', { key: '相続のせんせいを知ったきっかけ' })))
            }
          }
          var validatePhone = (rule, value, callback) => {
            if (!this.form.contactUs.includes('電話')) callback()
            if ((typeof this.form.phone === 'undefined' || this.form.phone.length === 0 || this.form.phone === '') &&
             (typeof this.form.mobilePhone === 'undefined' || this.form.mobilePhone.length === 0 || this.form.mobilePhone === '')) {
              callback(new Error(this.$t('rules.required', { key: '電話番号または携帯電話番号' })))
            } else {
              callback()
            }
          }
          var validateMobilePhone = (rule, value, callback) => {
            if (!this.form.contactUs.includes('電話')) callback()
            if ((typeof this.form.phone === 'undefined' || this.form.phone.length === 0 || this.form.phone === '') &&
             (typeof this.form.mobilePhone === 'undefined' || this.form.mobilePhone.length === 0 || this.form.mobilePhone === '')) {
              callback(new Error(this.$t('rules.required', { key: '電話番号または携帯電話番号' })))
            } else {
              callback()
            }
          }
            return {
                form: {
                    firstName: '',
                    lastName: '',
                    lastNameKana: '',
                    firstNameKana: '',
                    phone: '', // phone
                    mobilePhone: '',
                    email: '',
                    contentOfConsultation: '',
                    contactUs: [],
                    inquiryConsultationDetail: [],
                    learnedAbout: '',
                    searchKeyword: '',
                    financialInstitution: '',
                    bankBranch: '',
                    other: '',
                    otherText: '',
                    consultantTaxAdvisor: '',
                    prefecture: '',
                    privacyPolicy: false,
                    beginDate: '',
                    beginDateFirst: '',
                    beginDateSecond: '',
                    beginDateThird: '',
                    meetingPlace: [],
                    beginHour: '',
                    hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
                    beginHourFirst: '',
                    beginHourSecond: '',
                    beginHourThird: '',
                    beginHours: ['9:00', '9:30', '10:00', '10:30', '11:00', '13:00', '13:30', '14:00', '14:30', '15:00',
                                '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00']
                },
                rules: {
                  lastName: [
                      { required: true, message: this.$t('rules.required', { key: this.$t('member.last_name') }), trigger: 'blur' }
                  ],
                  firstName: [
                      { required: true, message: this.$t('rules.required', { key: this.$t('member.first_name') }), trigger: 'blur' }
                  ],
                  inquiryConsultationDetail: [
                    { validator: validateInquiryConsultationDetail, trigger: 'change' }
                  ],
                  phone: [
                      { required: false, pattern: /^(?:\d{2}-\d{4}|\d{3}-\d{3}|\d{4}-\d{2}|\d{5}-\d)-\d{4}$/, message: this.$t('rules.number', { key: this.$t('member.phone') }), trigger: 'blur' },
                      {　validator: validatePhone, trigger: 'blur' }
                  ],
                  mobilePhone: [
                      { required: false, pattern: /^\d{3}-\d{4}-\d{4}$/, message: this.$t('rules.number', { key: this.$t('member.mobile_phone') }), trigger: 'blur' },
                      { validator: validateMobilePhone, trigger: 'blur' }
                  ],
                  prefecture: [
                      { required: true, message: this.$t('rules.required', { key: 'お住いの都道府県' }), trigger: 'blur' }
                  ],
                  contactUs: [
                      { validator: validateContactUs, trigger: 'blur' }
                  ],
                  knowAbout: [
                      { validator: validateKnowOutWeb, trigger: 'blur' }
                  ]
                },
                prefectureMaster: [],
                inquiryConsult: [],
                inquiryContact: [],
                inquirySerch: [],
                inquiryAdvisor: [],
                policy: true,
                policy2: false,
                memberId: '',
                holiday: [],
                soonestWorkingDayForFirstChoice: '',
                soonestWorkingDayForSecondAndThirthChoice: '',
                formDisabled: false,
                isConfirm: false,
                checkPolicy: false
            }
        },
        computed: {
            ...mapGetters(['currentUser', 'isAuthenticated']),
            beginDatePickerOptions () {
              let self = this
              return {
                disabledDate (date) {
                  if (self.form.beginDate === null) return false
                  return self.isValidDateForThirthChoice(date)
                }
              }
            },
            beginDatePickerOptionsForFirstAndSecondChoice () {
              let self = this
              return {
                disabledDate (date) {
                  if (self.form.beginDate === null) return false
                  return self.isValidDateForFirstAndSecondChoice(date)
                }
              }
            }
        },
        mounted () {
          ApiHoliday.getHoliday().then(response => {
            if (response.data.status === 200) {
              let data = response.data.data
              data.map(h => { if (h.legacy) this.holiday.push(h.date) })
            }
          })

          if (isIE()) {
              this._$('.begin-date input[type="text"]').on('focus', event => event.currentTarget.blur())
              this._$('.begin-hour-group input[type="text"]').css('pointer-events', 'none')
              this._$('.begin-hour-group input[type="text"]').on('focus', event => event.currentTarget.blur())
          }
        },
        methods: {
            registerContact () {
              this.$refs['form'].validate((valid) => {
                if (valid && (!this.policy)) {
                  this.checkPolicy = false
                  this.isConfirm = true
                  this.formDisabled = true
                } else {
                  if (this.policy) {
                      this.checkPolicy = true
                  } else {
                      this.checkPolicy = false
                  }
                  this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
                  return false
                }
              })
            },
            prefectureChange () {
                this.$refs['confirm-before-route'].change()
            },
            handleBack () {
                this.formDisabled = false
                this.isConfirm = false
            },
            alertMessage (message, title) {
              this.$alert(message, title, {
                  confirmButtonText: this.$t('commons.ok')
              })
            },
            trim (str) {
                return str ? str.trim() : null
            },
            appendString (str1, str2) {
                str1 = str1 || ''
                str2 = str2 || ''
                return str1 + str2
            },
            sendEmail () {
                let firstName = this.trim(this.form.firstName)
                let lastName = this.trim(this.form.lastName)
                let lastNameKana = this.trim(this.form.lastNameKana)
                let firstNameKana = this.trim(this.form.firstNameKana)
                let phone = this.trim(this.form.phone)
                let mobilePhone = this.trim(this.form.mobilePhone)
                let email = this.trim(this.form.email)
                let contentOfConsultation = this.trim(this.form.contentOfConsultation)
                let inquiryConsultationDetail = this.form.inquiryConsultationDetail.join(',')
                let meetingPlace = this.trim(this.form.meetingPlace.join(','))
                let firstPreferredDate = this.trim(this.form.beginDateFirst + ' ' + this.form.beginHourFirst)
                let secondPreferredDate = this.trim(this.form.beginDateSecond + ' ' + this.form.beginHourSecond)
                let thirdPreferredDate = this.trim(this.form.beginDateThird + ' ' + this.form.beginHourThird)
                let contactUs = this.form.contactUs.join(',')
                let searchEngine = this.trim(this.form.learnedAbout)
                let searchKeyword = this.trim(this.form.searchKeyword)
                // 金融機関、その他についてチェックしなくても常にメールに表示する
                // let financialInstitution = this.form.financialInstitution ? this.form.bankBranch.trim() : null
                let financialInstitution = this.form.bankBranch.trim()
                // let other = this.form.other ? this.form.otherText.trim() : null
                let other = this.form.otherText.trim()
                let consultantTaxAdvisor = this.trim(this.form.consultantTaxAdvisor)
                let prefecture = this.trim(this.form.prefecture)
                let data = {
                    memberName: lastName + firstName,
                    memberNameKana: this.appendString(lastNameKana, firstNameKana),
                    phone: phone,
                    mobilePhone: mobilePhone,
                    email: email,
                    firstPreferredDate,
                    secondPreferredDate,
                    thirdPreferredDate,
                    meetingPlace,
                    inquiryConsultationDetail,
                    contentOfConsultation,
                    contactUs,
                    searchEngine,
                    searchKeyword,
                    financialInstitution,
                    other,
                    consultantTaxAdvisor,
                    prefecture
                }
                contact.sendEmail(data).then(response => {
                   this.openDialog(response.data.code, response.data.message)
                })
            },
            resetForm () {
                this.$refs['confirm-reset-form'].open({
                  message: '入力内容がクリアされますがよろしいですか？'
                }).then((confirm) => {
                    if (confirm) {
                        this.form.firstName = ''
                        this.form.lastName = ''
                        this.form.lastNameKana = ''
                        this.form.firstNameKana = ''
                        this.form.phone = ''
                        this.form.mobilePhone = ''
                        this.form.email = ''
                        this.form.contentOfConsultation = ''
                        this.form.contactUs = []
                        this.form.meetingPlace = []
                        this.form.inquiryConsultationDetail = []
                        this.form.beginDateFirst = ''
                        this.form.beginDateSecond = ''
                        this.form.beginDateThird = ''
                        this.form.beginHourFirst = ''
                        this.form.beginHourSecond = ''
                        this.form.beginHourThird = ''
                        this.form.learnedAbout = ''
                        this.form.searchKeyword = ''
                        this.form.financialInstitution = ''
                        this.form.bankBranch = ''
                        this.form.other = ''
                        this.form.otherText = ''
                        this.form.consultantTaxAdvisor = ''
                        this.form.prefecture = ''
                        this.form.privacyPolicy = false
                        this.form.beginDate = ''
                        this.$refs['confirm-before-route'].reset()
                        this.policy = true
                        this.policy2 = false
                    }
                })
            },
            getDataChoiceItem () {
                contact.getInformPrefectureMaster().then(response => {
                    if (response.data.data.length > 0) {
                        this.prefectureMaster = response.data.data
                    }
                })
                contact.getChoiceItemData().then(response => {
                  if (response.data.data.inquiry_consultation_detail.value.length > 0) {
                        this.inquiryConsult = response.data.data.inquiry_consultation_detail.value
                    }
                    if (response.data.data.inquiry_contact.value.length > 0) {
                        this.inquiryContact = response.data.data.inquiry_contact.value
                    }
                    if (response.data.data.inquiry_serch.value.length > 0) {
                        this.inquirySerch = response.data.data.inquiry_serch.value
                    }
                    if (response.data.data.inquiry_advisor.value.length > 0) {
                        this.inquiryAdvisor = response.data.data.inquiry_advisor.value
                    }
                })
            },
            handlePrivacyPolicy () {
                if (this.form.privacyPolicy === true) {
                    this.policy2 = true
                    this.policy = false
                } else {
                    this.policy = true
                    this.policy2 = false
                }
            },
            openDialog (code, msg) {
                MessageBox({
                    title: msg,
                    showClose: true,
                    center: true,
                    confirmButtonClass: 'btn-msg-box'
                }).then(() => {
                  this.$refs['confirm-before-route'].reset()
                  window.app.$router.push({ name: 'portal' })
                })
                setTimeout(() => {
                  MessageBox.close()
                  this.$refs['confirm-before-route'].reset()
                  window.app.$router.push({ name: 'portal' })
                }, 2000)
            },
            fetchData () {
                this.memberId = this.currentUser === null ? null : this.currentUser.id
                if (this.memberId !== undefined || this.memberId !== '') {
                    this.showdata()
                }
            },
            showdata () {
                this.form.firstName = this.currentUser.firstName
                this.form.lastName = this.currentUser.lastName
                this.form.lastNameKana = this.currentUser.lastNameKana
                this.form.firstNameKana = this.currentUser.firstNameKana
                this.form.phone = this.currentUser.phone
                this.form.mobilePhone = this.currentUser.mobilePhone
                this.form.prefecture = this.currentUser.prefecture
                this.form.email = this.currentUser.email
            },
            isWeekend (date) {
              let day = moment(date).toDate().getDay()
              return ((day === 6) || (day === 0))
            },
            isNextWorkingDay (date) {
              var i = 1
              let nextWorkingDay = moment().add(i, 'day')
              while (this.isLegacyHoliday(nextWorkingDay)) {
                i++
                nextWorkingDay = moment().add(i, 'day')
              }
              return moment(date).isSame(nextWorkingDay, 'day')
            },
            isNextNextWorkingDayAndNowIsInTheAfternoon (date) {
              let timeNow = moment().format('HH')
              if (timeNow >= 12) {
                var i = 1
                let nextWorkingday = moment().add(i, 'day')
                // if nextWokingday variable contains legacy holiday
                // then it is not next working day
                // Need to loop to find next working day
                while (this.isLegacyHoliday(nextWorkingday)) {
                  i++
                  nextWorkingday = moment().add(i, 'day')
                }
                // Add one more day to get next next working day
                let nextNextWorkingDay = moment().add(++i, 'day')
                // Same as next workingday
                // Need to loop to get rid of legacy holiday
                while (this.isLegacyHoliday(nextNextWorkingDay)) {
                  i++
                  nextNextWorkingDay = moment().add(i, 'day')
                }
                return moment(date).isSame(nextNextWorkingDay, 'day')
              }
            },
            isNextWorkingDayAndNowIsInTheAfternoon (date) {
              let timeNow = moment().format('HH')
              if (timeNow >= 12) {
                var i = 1
                let nextWorkingDay = moment().add(i, 'day')
                while (this.isLegacyHoliday(nextWorkingDay)) {
                  i++
                  nextWorkingDay = moment().add(i, 'day')
                }
                return moment(date).isSame(nextWorkingDay, 'day')
              }
            },
            isLegacyHoliday (date) {
              return this.holiday.includes(moment(date).format('YYYY-MM-DD'))
            },
            isPass35daysFromSoonestWorkingDay (date, soonestWorkingDay) {
              var days = moment(date).diff(moment(soonestWorkingDay), 'day')
              return days > 35
            },
            isValidDateForThirthChoice (date) {
              var isUnableToSelect = moment(date).isBefore(moment()) || this.isLegacyHoliday(date) || this.isNextWorkingDay(date) || this.isNextNextWorkingDayAndNowIsInTheAfternoon(date) || this.isLegacyMoveDate(date)
              if (!isUnableToSelect && this.soonestWorkingDayForSecondAndThirthChoice === '') this.soonestWorkingDayForSecondAndThirthChoice = date
              return (isUnableToSelect || this.isPass35daysFromSoonestWorkingDay(date, this.soonestWorkingDayForSecondAndThirthChoice))
            },
            isValidDateForFirstAndSecondChoice (date) {
              var isUnableToSelect = moment(date).isBefore(moment()) || this.isLegacyHoliday(date) || this.isNextWorkingDayAndNowIsInTheAfternoon(date) || this.isLegacyMoveDate(date)
              if (!isUnableToSelect && this.soonestWorkingDayForFirstChoice === '') this.soonestWorkingDayForFirstChoice = date
              return (isUnableToSelect || this.isPass35daysFromSoonestWorkingDay(date, this.soonestWorkingDayForFirstChoice))
            },
            isLegacyMoveDate (date) {
              // 移転日には面談出来ないのでカレンダーで選択不可にする特別対応
              var isUnableToSelect = moment(date).isBetween(moment('2023-06-24'), moment('2023-06-25'), null, '[]')
              return isUnableToSelect
            }
        },
        created () {
            window.scrollTo(0, 0)
            this.getDataChoiceItem()
            this.fetchData()
            this.$bus.$on('refreshData', (data) => {
                if (this.$route.name === data) {
                    this.fetchData()
                }
            })
        },
        beforeRouteLeave (to, from, next) {
          this.$refs['confirm-before-route'].openConfirm().then((confirm) => {
            if (confirm) {
              next()
            } else {
              next(false)
            }
          })
        }
    }
</script>
<style>
  .contact p {
    font-size: 16px;
  }

  .contact .table {
    background: #fff;
    border-left: 2px solid #c0b283;
    border-top: 2px solid #c0b283;
    width: 100%;
  }
  _:-ms-lang(x)::-ms-backdrop, .contact .table {
    table-layout: fixed;
  }
  .contact .table .title,
  .contact .table td {
    border-bottom: 2px solid #c0b283;
    border-right: 2px solid #c0b283;
    padding: 1em;
  }

  .contact .table td,
  .contact .table td input,
  .contact .table td span {
    font-size: 14px !important;
  }

  .contact .table td.title {
    font-size: 16px !important;
  }

  .contact .table .title {
    background: #f7f0df;
    font-weight: bold;
    text-align: left;
    width:300px;
  }

  .contact .table td {
    vertical-align: middle;
    background: #fffdf7;
  }

  .contact .begin-date {
      flex-basis: calc(50% - 10px);
  }
  .contact .form-required {
    float: right;
  }

  .w-45p {
    width: 45%;
  }

  .contact .btn-contact .danger {
    padding: 1.5em 5em;
    font-weight: bold;
    border: 1px solid #c0b283;
    font-size: 18px;
  }
  .title-screen {
      padding-bottom: 0px;
  }

  .font_standard .reed_color {
      font-size: 14px;
  }

  .reed_color {
      background-repeat: no-repeat;
      line-height: 41px;
      font-weight: bold;
      color: #887861;
      padding-left: 22px;
      margin-top: 30px;
      clear: both;
      background-color: #e6e2db;
      position: relative;
  }

  .al-c {
      text-align: center !important;
      line-height: 25px;
      padding-top: 20px;
  }

  img {
      max-width: 100%;
  }

  .reed03 {
      line-height: 20px;
      font-weight: bold;
      margin-top: 20px;
      margin-bottom: 10px;
      padding-left: 10px;
      clear: both;
      position: relative;
  }

  .reed_color::before {
      content: "";
      width: 3px;
      height: calc(100% - 12px);
      position: absolute;
      top: 6px;
      left: 8px;
      background: -webkit-linear-gradient(top, #988d7b 0%, #746347 100%);
      display: block;
  }

  .reed03::before {
      content: "";
      width: 5px;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background: -webkit-linear-gradient(top, #988d7b 0%, #746347 100%);
      display: block;
  }

  .bold-txt {
      font-weight: bold !important;
      line-height: 25px;
      padding-top: 20px;
  }

  #contact_btn {
      clear: both;
      padding-top: 0;
      overflow: hidden;
  }

  #contact_btn p {
      padding-top: 0;
  }

  #contact_btn .float-l {
      display: block;
      height: 72px;
      background-image: url(../../../images/contact_text03_bg.jpg);
      background-repeat: no-repeat;
      color: #FFF;
      font-size: 25px;
      line-height: 20px;
      float: left;
  }

  #contact_btn .float-l span {
      padding-top: 16px;
      padding-left: 127px;
      display: block;
  }

  #contact_btn .float-l a {
      display: block;
      height: 72px;
      width: 306px;
      color: #FFF;
  }

  #contact_btn .float-l #business_hours {
      font-family: "メイリオ", "Arial", sans-serif;
      font-size: 10px;
      font-weight: bold;
      padding-top: 7px;
      padding-left: 88px;
      transform: scale(0.97);
  }

  #contact_btn ul {
      background-image: url(../../../images/contact_btn_bg.jpg);
      background-repeat: no-repeat;
      background-position: center top;
      padding-top: 12px;
      height: 72px;
      width: 932px;
  }

  #contact_btn ul li{
      float: left;
  }

  .link01 a:hover {
      text-decoration: none;
      color: #820404;
  }

  a {
      outline: none;
      color: #333333;
      text-decoration: underline;
  }

  .contact .table td div .el-form-item__error {
    font-size: 15px !important;
  }

  @media screen and (max-width: 680px) {
    #contact_btn ul {
      width: 100%;
      background-position: right top;
    }
    #contact_btn .float-l {
      width: 400px;
    }
    #contact_btn ul li {
      width: 48.5%;
      font-size: 14px;
      text-align: center;
      margin-top: 10px;
    }
    #contact_btn ul li:nth-child(1) {
      margin-right: 3%;
    }
    #contact_btn ul li:nth-child(1) a::before {
      content: '初回無料相談フォーム';
    }
    #contact_btn ul li:nth-child(2) a::before {
      content: '資料請求';
    }

    #contact_btn ul li a img {
      display: none;
    }
    #contact_btn ul li a {
      height: 100%;
      padding: 10px;
      color: #fff;
      background-color: #942828;
      display: block;
      border-radius: 5px;
      text-decoration: none;
    }
  }
  @media screen and (max-width: 500px) {
    .contact .btn-contact .danger {
      padding: 1em 2.5em;
      font-weight: bold;
      border: 1px solid #c0b283;
      font-size: 14px;
    }
  }

  .contact tr td.email-contact .el-form-item {
    margin-bottom: 10px;
  }

  .contact .max-width-300 {
    max-width: 300px;
  }

  .contact tr td.prefecture-contact {
    vertical-align: center;
  }

  .begin-date .el-input--prefix .el-input__inner {
    padding-left: 30px !important;
  }

  _:-ms-lang(x)::-ms-backdrop, .contact .begin-date {
      flex-basis: 160px;
  }
  .begin-hour {
    width: 80px;
    margin-left: 20px;
  }

  .begin-date .begin-date-group {
    display: inline-flex;
    padding: 5px;
      width: 100%;
  }

  .begin-date .begin-date-group .title-date-group {
      flex-basis: 100px;
  }
  .begin-hour-group {
    flex-basis: calc(50% - 10px);
    margin-left: 20px;
  }
  _:-ms-lang(x)::-ms-backdrop, .begin-hour-group {
    flex-basis: 160px;
  }

  .button-large-height {
    min-width: 264px;
    min-height: 60px;
  }

  .date-group{
      display: flex;
      flex-flow: row wrap;
  }

  .el-date-picker .el-date-table .disabled div{
    background-color: #DDDDDD;
  }

  .el-date-picker .el-date-table .available div{
    font-weight: bold;
  }

  .float-none {
    float: none !important;
  }

  @media screen and (max-width: 480px) {
    .begin-hour {
      margin-left: 10px;
    }
      .begin-hour-group {
          margin-left: 0px !important;
          margin-top: 10px;
      }
      .date-group{
          display: flex;
          flex-flow: column;
      }
  }
  @media screen and (max-width: 570px) {
    .contact .confirm-change-before-route .btn-contact {
      display: flex;
      flex-flow: column;
      align-items: center;
    }
    .contact .confirm-change-before-route .btn-contact button {
      margin: 5px 0;
      max-width: 264px;
    }
  }
  @media screen and (max-width: 768px) {
    .contact .table .title {
      width: 100%;
    }
  }
  .contact {
      margin-top: 0 !important;
  }
  .warning-policy {
      font-size: 0.8em;
  }
  @media screen and (min-width: 769px) {
      .privacy-policy .el-checkbox__inner {
          top: -2px;
      }
  }
</style>
<style>
    @import "../../../assets/css/custom.css";
</style>
